import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import action from "../actions";
import { showAlert } from "../../../config/utils";
import OuterDraggable from "react-draggable";
import RightArrowIcon from "../../../assets/img/arrow-right-btn.svg";
import ViewExportModal from "../../recommendations/components/ExportSettingsModal";
import Portal from "../../common/components/Portal";

const AssetExportPopup = ({
    onCancel,
    handleSubmit,
    loading = false,
    tableData,
    clientIdForSmartChart,
    projectIdForSmartChart,
    groupingOptions = []
}) => {
    const dispatch = useDispatch();

    const [transform, setTransform] = useState({ left: 0, top: 0 });
    const [showAssetTableExportSettings, setShowAssetTableExportSettings] = useState(false);
    const [assetExportSettingsId, setAssetExportSettingsId] = useState("");
    const [assetExportGrouping, setAssetExportGrouping] = useState("");
    const [assetExportGroupingFirst, setAssetExportGroupingFirst] = useState("");
    const [assetExportGroupingSecond, setAssetExportGroupingSecond] = useState("");

    const { exportGroupingDropdownExport } = useSelector(state => state.assetReducer);

    /* ------------------ API CALL ------------------ */
    useEffect(() => {
        dispatch(action.getExportGroupingDropdown());
    }, [dispatch]);
    useEffect(() => {
        if (
            !exportGroupingDropdownExport?.success &&
            exportGroupingDropdownExport?.message ||
            exportGroupingDropdownExport?.error ||
            typeof exportGroupingDropdownExport?.detail === "string"
        ) {
            showAlert(exportGroupingDropdownExport?.message ?? exportGroupingDropdownExport?.error ?? exportGroupingDropdownExport?.detail);
        }
    }, [exportGroupingDropdownExport]);

    /* ------------------ HANDLERS ------------------ */
    const handleDrag = (e, ui) => {
        setTransform({ left: ui.x, top: ui.y });
    };

    const handleSave = currentExportType => {
        const grouping = assetExportGroupingFirst
            ? [assetExportGroupingFirst, ...(assetExportGroupingSecond ? [assetExportGroupingSecond] : [])]
            : [];

        handleSubmit({
            exportType: currentExportType,
            grouping: currentExportType === "grouping" ? grouping : [],
            ...(currentExportType === "grouping" && assetExportSettingsId ? { settings_id: assetExportSettingsId } : {})
        });
    };

    const renderAssetTableExportSettings = () => {
        if (!showAssetTableExportSettings) return null;

        return (
            <Portal
                body={
                    <ViewExportModal
                        keys={tableData.keys}
                        config={tableData.config}
                        tableData={tableData}
                        onCancel={() => setShowAssetTableExportSettings(false)}
                        isAssetExportSettingsview
                        clientIdForSmartChart={clientIdForSmartChart}
                        projectIdForSmartChart={projectIdForSmartChart}
                        setNormalRecomData={({ settingsId, groupingData, groupingFirst, groupingSecond }) => {
                            setAssetExportSettingsId(settingsId);
                            setAssetExportGrouping(groupingData);
                            setAssetExportGroupingFirst(groupingFirst);
                            setAssetExportGroupingSecond(groupingSecond);
                        }}
                        smartChartTileConfig={{
                            settings_id: assetExportSettingsId,
                            band1: {
                                settings_id: assetExportSettingsId,
                                grouping: assetExportGrouping,
                                grouping_first: assetExportGroupingFirst,
                                grouping_second: assetExportGroupingSecond
                            }
                        }}
                        normalRecomConfig={{
                            settingsId: assetExportSettingsId,
                            grouping: assetExportGrouping,
                            grouping_first: assetExportGroupingFirst,
                            grouping_second: assetExportGroupingSecond
                        }}
                        groupingOptions={groupingOptions}
                        isAssetBand
                        grouping={true}
                        isRegularTableView
                        hasNoTemplateDropdown={true}
                    />
                }
                onCancel={() => setShowAssetTableExportSettings(false)}
            />
        );
    };

    /* ------------------ JSX ------------------ */
    return (
        <div
            className="modal modal-region add-image-modal img-pop-small excel-accord-modal asset-export-modal"
            id="modalId"
            style={{ display: "block" }}
            tabIndex="-1"
        >
            <OuterDraggable handle=".draggable" cancel=".not-draggable" onDrag={handleDrag}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content outerModal_draggable" style={transform}>
                        <div className="modal-body region-otr draggable export-type-body">
                            <div className="close-btn-area">
                                <button type="button" className="close not-draggable" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="close" />
                                    </span>
                                </button>
                            </div>
                            <div className="export-accord-outer">
                                <div className="card content-area mt-3 not-draggable">
                                    <div id="headingOne" className="cursor-pointer asset-exportheading">
                                        Simple Export
                                    </div>
                                    <div className="card-body">
                                        <div className="down-area">
                                            <button
                                                type="button"
                                                className="btn btn-download"
                                                onClick={() => handleSave("regular")}
                                                disabled={loading}
                                            >
                                                Download File{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordion">
                                    <div className="card content-area mt-3 not-draggable">
                                        <div
                                            id="headingTwo"
                                            className="cursor-pointer asset-exportheading"
                                        >
                                            Asset Grouping
                                        </div>
                                        <div className="down-area mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-download outdated"
                                                onClick={() => setShowAssetTableExportSettings(true)}
                                            >
                                                Advanced Export Settings <img src={RightArrowIcon} className="ml-1" alt="" />
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-download"
                                                onClick={() => handleSave("grouping")}
                                                disabled={loading}
                                            >
                                                Download File
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </OuterDraggable>
            {renderAssetTableExportSettings()}
        </div>
    );
};

export default AssetExportPopup;
